import Vue from 'vue'

Vue.filter('dateFormatShort', (string) => {
  const dateObj = new Date(string)
  return new Intl.DateTimeFormat('fr-CA', {
    dateStyle: 'short',
  }).format(dateObj)
})
